var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alarm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.74,4.688l-4.204-2.152L14.93,1.77c0.34-0.66,1.062-0.967,1.61-0.686l2.213,1.131c0.549,0.282,0.72,1.046,0.38,1.707 L18.74,4.688z M20.783,12.228c0,2.941-1.456,5.54-3.686,7.131l1.299,2.802c0,0,0.055,0.497-0.438,0.737 c-0.532,0.264-0.913-0.084-0.913-0.084l-1.279-2.676c-1.141,0.543-2.418,0.846-3.766,0.846c-1.349,0-2.625-0.303-3.768-0.846 l-1.28,2.678c0,0-0.379,0.35-0.914,0.086c-0.491-0.242-0.435-0.737-0.435-0.737l1.299-2.806c-2.231-1.592-3.688-4.189-3.688-7.131 c0-4.837,3.933-8.759,8.785-8.759C16.852,3.468,20.783,7.39,20.783,12.228z M12,5.396c-3.781,0-6.846,3.056-6.846,6.827 S8.219,19.05,12,19.05s6.846-3.056,6.846-6.827S15.781,5.396,12,5.396z M10.113,15.878c0.001,0.009-0.406,0.399-0.785,0.086 c-0.431-0.337-0.101-0.812-0.107-0.812c0.413-0.555,1.828-2.445,1.838-2.461c0.23-0.33,0.311-0.546,0.341-0.728l0.004-5.187 c0.003-0.003,0.018-0.513,0.606-0.509c0.5-0.005,0.581,0.518,0.581,0.518v5.2c0,0,0.037,0.515-0.504,1.167 C12.07,13.182,10.359,15.543,10.113,15.878z M4.847,3.918C4.507,3.26,4.678,2.5,5.229,2.22l2.214-1.125 c0.551-0.28,1.273,0.025,1.613,0.683L9.45,2.539L5.242,4.68L4.847,3.918z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarm);
export default __webpack_public_path__ + "static/media/ic_alarm.036dbb6a936af61d08180045e84074e6.svg";
export { ForwardRef as ReactComponent };